import {Icon} from 'front-onceforall-core';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Tooltip} from '@material-ui/core';

function FieldView(props) {
  const securedValue = () => '************';

  return (
    <>
      <h3 className="flex-container">
        <Translate value={`mandate.field.${props.field.key}`}/>
        {!props.field.secured &&
          <Tooltip title={<Translate value="mandate.details.information.copyToClipboard"/>}>
            <span>
              <button
                className="button-square information-primary"
                onClick={props.onCopyValue}
              >
                <Icon
                  icon="document-copy"
                  size={18}
                />
              </button>
            </span>
          </Tooltip>
        }
      </h3>
      <div>
        {props.field.secured ?
          securedValue() :
          props.field.value
        }
      </div>
      {!props.isLast && <hr className="my-4"/>}
    </>
  );
}

FieldView.propTypes = {
  field: PropTypes.object.isRequired,
  decryptedValue: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  onShowValue: PropTypes.func.isRequired,
  onCopyValue: PropTypes.func.isRequired,
  isLast: PropTypes.bool.isRequired
};

export default FieldView;
